import 'bootstrap/dist/js/bootstrap.bundle.js'

import 'unpoly/unpoly.js'
import 'unpoly/unpoly.css'
import 'unpoly/unpoly-bootstrap5.js'
import 'unpoly/unpoly-bootstrap5.css'

import './application/bootstrap.sass'
import './application/theme.sass'
import './application/unpoly_config.js'
import './application/network_graph.js'

// Registers static images in the asset manifest so views can resolve them via
// image_tag/image_url (precompiled_assets). The 'file' loader (see
// esbuild.config.js) compiles each import to a hashed URL string rather than a
// bare ESM `import './x.png'` statement — the latter is fetched by the browser
// as a module script and rejected on MIME type (image/png), which aborts the
// entire bundle and would leave Unpoly (window.up) undefined. The exported
// references keep esbuild from tree-shaking these otherwise-unused imports.
import makandraLogo from './images/makandra_logo.png'
import ogImage from './images/og_image.png'
import screenshotProjekt from './images/screenshot_projekt.png'
import screenshotFindings from './images/screenshot_findings.png'
import thomasEisenbarth from './images/thomas_eisenbarth.jpg'
import makandraKunden from './images/makandra_kunden.png'
import screenshotAgentBoot from './images/screenshot_agent_boot.png'
import screenshotAgentConnected from './images/screenshot_agent_connected.png'

export const ASSETS = { makandraLogo, ogImage, screenshotProjekt, screenshotFindings, thomasEisenbarth, makandraKunden, screenshotAgentBoot, screenshotAgentConnected }
